import classNames from 'classnames';
import React, { useState, useCallback } from 'react';
import { Nav } from 'react-bootstrap';

export interface FilterTabItem {
  label: string;
  value: string;
  onClick?: () => void;
  count: number;
}

interface FilterTabProps {
  tabItems: FilterTabItem[];
  className?: string;
}

const FilterTab = ({ tabItems, className }: FilterTabProps) => {
  const [activeItem, setActiveItem] = useState(tabItems[0]?.value || 'all'); // Dynamic default

  const handleClick = useCallback((item: FilterTabItem) => {
    setActiveItem(item.value);
    if (item.onClick) {
      item.onClick();
    }
  }, []);

  return (
    <Nav className={classNames(className, 'nav nav-links mx-n2')} role="tablist">
      {tabItems.map((item) => (
        <Nav.Item key={item.value}>
          <Nav.Link
            onClick={activeItem !== item.value ? () => handleClick(item) : undefined}
            className={classNames('px-2 py-1', { 
              active: activeItem === item.value,
              'disabled-link': activeItem === item.value // Add disabled-link class when active
            })}
            role="tab"
            aria-selected={activeItem === item.value}
            style={activeItem === item.value ? { cursor: 'default', pointerEvents: 'none' } : undefined}
          >
            {item.label}{' '}
            <span className="text-body-tertiary fw-semibold">
              ({item.count})
            </span>
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};

export default FilterTab;
